// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"D8-z"};